import React from 'react';

const CopySuccess = (props: object) => {
  return (
    <svg
      width={44}
      height={44}
      viewBox="0 0 44 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M40.3327 20.3501V12.6501C40.3327 6.23341 37.766 3.66675 31.3493 3.66675H23.6493C17.2327 3.66675 14.666 6.23341 14.666 12.6501V14.6667H20.3493C26.766 14.6667 29.3327 17.2334 29.3327 23.6501V29.3334H31.3493C37.766 29.3334 40.3327 26.7667 40.3327 20.3501Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.3327 31.3501V23.6501C29.3327 17.2334 26.766 14.6667 20.3494 14.6667H12.6493C6.23268 14.6667 3.66602 17.2334 3.66602 23.6501V31.3501C3.66602 37.7667 6.23268 40.3334 12.6493 40.3334H20.3494C26.766 40.3334 29.3327 37.7667 29.3327 31.3501Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.1465 27.5L14.7215 31.075L21.8532 23.925"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default CopySuccess;
